export default {
  data: function data() {
    return {};
  },
  methods: {}
};